import React, { useEffect, useState } from "react";

import { Box, Typography, keyframes } from "@mui/material";

import { theme } from "@/src/theme/theme";

import { Testimonial, getTestimonialList } from "@/src/utils/testimonialsUtils";

const fadeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Testimonials = () => {
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const [testimonialList, setTestimonialList] = useState<Testimonial[]>([]);
  const [currentTestimonial, setCurrentTestimonial] = useState<Testimonial>();

  useEffect(() => {
    const getInitialTestimonialList = async () => {
      const testimonialList = await getTestimonialList();
      setTestimonialList(testimonialList);
      setCurrentTestimonial(testimonialList[0]);
    };

    getInitialTestimonialList();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonialIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % testimonialList.length;
        setCurrentTestimonial(testimonialList[newIndex]);
        setIsFading(true);

        setTimeout(() => {
          setIsFading(false);
        }, 3000);

        return newIndex;
      });
    }, 8000);

    return () => {
      clearInterval(interval);
    };
  }, [testimonialList]);

  return (
    <Box
      sx={{
        textAlign: "center",
        mt: 2,
        mx: 4,
        animation: isFading ? `${fadeAnimation} 3s linear` : "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: [220, 180]
      }}
    >
      <Typography
        variant="h2"
        sx={{
          maxWidth: 700,
          fontWeight: theme.typography.fontWeightRegular,
          color: theme.palette.semantic.primary.main,
          padding: 0,
          fontStyle: "italic"
        }}
      >
        {currentTestimonial ? <q>{currentTestimonial?.text}</q> : ""}
      </Typography>
    </Box>
  );
};

export default Testimonials;
